// import { Calendar } from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
// import "bootstrap-daterangepicker/daterangepicker.css";
// import DateRangePicker from "react-bootstrap-daterangepicker";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import {
  API_BASE_URL,
  GET_DDL,
  GET_USER_PERMISSIONS,
  GET_ACCOUNTS_DASHBOARD,
} from "../../Config";
import NoOfStores from "./noofstores.svg";
import Purchase from "./purchase.svg";
import Supplier from "./supplier.svg";
// import Sales from "./sales.svg";
import StockValue from "./stockvalue.svg";
import ViewIndent from "../../core/modals/purchases/viewindent";
import ViewPurchaseRequest from "../../core/modals/purchases/viewpurchaserequest";
// import SupplierModal from "../../core/modals/peoples/supplierModal";
// import ViewInvocie from "../../core/modals/purchases/viewinvoice";
// import ViewPurchase from "../../core/modals/purchases/viewpurchase";

const AccountsDashboard = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [dashboardTablesData, setDashboardTablesData] = useState([]);
  const [viewIndentObj, setViewIndentObj] = useState([]);
  const [viewPRObj, setViewPRObj] = useState([]);
  // const [viewPOObj, setViewPOObj] = useState([]);
  // const [viewSupplierObj, setViewSupplierObj] = useState([]);
  // const [viewInvoiceObj, setViewInvoiceObj] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  //   const storeId = sessionStorage.getItem("selectedStoreId");
  // useEffect(() => {
  //   setSelectedStoreId(storeId);
  //   console.log(selectedStoreId, "localstoreage storeid", storeId);
  // }, [storeId]);

  // useEffect(() => {
  //   const storeId = localStorage.getItem("selectedStoreId");
  //   setSelectedStoreId(storeId);
  //   console.log(selectedStoreId, "localstoreage storeid", storeId);
  // }, []);

  useEffect(() => {
    const fetchDashboardData = async () => {
      const table_api = `${API_BASE_URL}${GET_ACCOUNTS_DASHBOARD}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`;
      console.log(table_api, "for allllllllllllllllllllllllllllllll");
      try {
        const tablesResponse = await Axios.get(table_api);
        setDashboardTablesData(tablesResponse.data);
        console.log(tablesResponse.data, "tableresposne.dataaaaa");
      } catch (error) {
        console.error(
          "Error fetching dashboard data:",
          error.response ? error.response.data : error.message
        );
      }
    };

    if (userDataSession && userDataSession.OrgId) {
      fetchDashboardData();
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      fetchUserPermissions();
    }
  }, [userDataSession]);

  const fetchUserPermissions = () => {
    Axios.get(
      `${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${userDataSession.RoleId}&ModuleId=0`
    )
      .then((response) => {
        // setUserPermissions(response.data.ResultData);
        sessionStorage.setItem(
          "UserPermissions",
          JSON.stringify(response.data.ResultData)
        );
        // console.log(response.data.ResultData, 'user permissonsss data....');
      })
      .catch((error) => {
        console.error("Error fetching user permissions:", error);
      });
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data) {
            const allData = response.data.ResultData;

            // Define the DDL names to filter
            const ddlNames = [
              "Supplier",
              "CATEGORY",
              "Subcategories",
              "Products",
              "variantypes",
              "TAX",
              "Stores",
              "BRAND",
              "Roles",
              "Staff",
              "Customers",
              "UNITS",
              "Cities",
            ];

            // Iterate through each DDL name, filter data, and save to session storage
            ddlNames.forEach((name) => {
              const filteredData = allData.filter(
                (item) => item.DDLName === name
              );
              sessionStorage.setItem(
                `filteredDDLData_${name}`,
                JSON.stringify(filteredData)
              );
            });

            console.log("Filtered data saved successfully");
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  //   useEffect(() => {
  //   if (userDataSession && userDataSession.OrgId) {
  //     Axios.get(
  //       `${API_BASE_URL}Admin/getOrgSettings?OrgId=${userDataSession.OrgId}`
  //     )
  //       .then((response) => {
  //         if (response.data) {
  //           sessionStorage.setItem(
  //             "OrgSettings",
  //             JSON.stringify(response?.data?.ResultData?.[0])
  //           );
  //           console.log("Org settings saved successfully");
  //         } else {
  //           console.error("Error fetching org settings:", response.data);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching org settings:", error);
  //       });
  //   }
  // }, [userDataSession]);

  const supplierData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Supplier")
  );
  const categoryData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_CATEGORY")
  );
  const subcategoryData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Subcategories")
  );
  const productData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Products")
  );
  const variantypesData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_variantypes")
  );
  const taxData = JSON.parse(sessionStorage.getItem("filteredDDLData_TAX"));
  const storesData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Stores")
  );
  const brandsData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_BRAND")
  );
  const rolesData = JSON.parse(sessionStorage.getItem("filteredDDLData_Roles"));
  const staffData = JSON.parse(sessionStorage.getItem("filteredDDLData_Staff"));
  const customerData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Customer")
  );
  const unitsData = JSON.parse(sessionStorage.getItem("filteredDDLData_UNITS"));
  const citiesData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Cities")
  );

  useEffect(() => {
    console.log(supplierData);
    console.log(categoryData);
    console.log(subcategoryData);
    console.log(variantypesData);
    console.log(taxData);
    console.log(productData);
    console.log(brandsData);
    console.log(rolesData);
    console.log(staffData);
    console.log(storesData);
    console.log(customerData);
    console.log(unitsData);
    console.log(citiesData);
  }, []);

  const showViewIndentModal = (dataObj) => {
    setViewIndentObj(dataObj);
  };

  const showViewPRModal = (dataObj) => {
    setViewPRObj(dataObj);
  };

  // const showViewPOModal = (dataObj) => {
  //   setViewPOObj(dataObj);
  // };

  // const showViewSupplierModal = (dataObj) => {
  //   setViewSupplierObj(dataObj);
  // };

  // const showViewInvoiceModal = (dataObj) => {
  //   setViewInvoiceObj(dataObj);
  // };

  // const initialSettings = {
  //   endDate: new Date("2020-08-11T12:30:00.000Z"),
  //   ranges: {
  //     "Last 30 Days": [
  //       new Date("2020-07-12T04:57:17.076Z"),
  //       new Date("2020-08-10T04:57:17.076Z"),
  //     ],
  //     "Last 7 Days": [
  //       new Date("2020-08-04T04:57:17.076Z"),
  //       new Date("2020-08-10T04:57:17.076Z"),
  //     ],
  //     "Last Month": [
  //       new Date("2020-06-30T18:30:00.000Z"),
  //       new Date("2020-07-31T18:29:59.999Z"),
  //     ],
  //     "This Month": [
  //       new Date("2020-07-31T18:30:00.000Z"),
  //       new Date("2020-08-31T18:29:59.999Z"),
  //     ],
  //     Today: [
  //       new Date("2020-08-10T04:57:17.076Z"),
  //       new Date("2020-08-10T04:57:17.076Z"),
  //     ],
  //     Yesterday: [
  //       new Date("2020-08-09T04:57:17.076Z"),
  //       new Date("2020-08-09T04:57:17.076Z"),
  //     ],
  //   },
  //   startDate: new Date("2020-08-04T04:57:17.076Z"),
  //   timePicker: false,
  // };

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  //   const year = date.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="welcome d-lg-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center welcome-text">
              <h3 className="d-flex align-items-center">
                <ImageWithBasePath src="assets/img/icons/hi.svg" alt="img" />
                &nbsp;Hi {userDataSession.Name},
              </h3>
              &nbsp;
              <h6>here&apos;s what&apos;s happening with your store today.</h6>
            </div>
            {/* <div className="d-flex align-items-center d-none">
              <div className="position-relative daterange-wraper me-2 d-none">
                <div className="input-groupicon calender-input">
                  <DateRangePicker
                    className="d-none"
                    initialSettings={initialSettings}
                  >
                    <input
                      className="form-control col-4 input-range d-none"
                      type="text"
                      style={{ cursor: "not-allowed" }}
                    />
                  </DateRangePicker>
                </div>
                <Calendar className="feather-14 d-none" />
              </div>
            </div> */}
          </div>
          <div className="row sales-cards justify-content-evenly">
            <div className="col-xl-3 col-sm-6 col-12">
              <Link to="/store-list">
                <div className="card color-info bg-primary mb-4">
                  <img src={NoOfStores} alt="img" style={{ width: "2.7rem" }} />
                  <h4 className="text-white">
                    {" "}
                    <CountUp
                      end={
                        dashboardTablesData &&
                        Array.isArray(dashboardTablesData.TotalStores) &&
                        dashboardTablesData.TotalStores.length > 0
                          ? dashboardTablesData.TotalStores[0]?.TotalStores
                          : 0
                      }
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>No of Stores</p>
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link to="/purchase-list">
                <div className="card color-info bg-success mb-4">
                  <img src={Purchase} alt="img" style={{ width: "2.7rem" }} />
                  <h4 className="text-white">
                    ₹
                    <CountUp
                      end={
                        dashboardTablesData && dashboardTablesData?.PendingAMt
                          ? dashboardTablesData?.PendingAMt[0].PendingAmt
                          : 0
                      }
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>Pending POs Amount</p>
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <div className="card color-info bg-secondary mb-4">
                <img
                  src={StockValue}
                  style={{ width: "2.7rem" }}
                  alt="supplier svg"
                />
                <h4 className="text-white">
                  ₹
                  <CountUp
                    end={
                      dashboardTablesData &&
                      dashboardTablesData.TotStockWorthCount
                        ? dashboardTablesData.TotStockWorthCount[0]
                            .StockWorthCount
                        : 0
                    }
                    duration={4}
                  >
                    +
                  </CountUp>
                </h4>
                <p>Total Stock Worth</p>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link to="/suppliers">
                <div className="card color-info bg-info mb-4">
                  <img
                    src={Supplier}
                    style={{ width: "2.7rem" }}
                    alt="supplier svg"
                  />
                  <h4 className="text-white">
                    ₹
                    <CountUp
                      end={
                        dashboardTablesData && dashboardTablesData.InvoiceAMt
                          ? dashboardTablesData.InvoiceAMt[0].Invoiceamt
                          : 0
                      }
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>Last Month PO Amount</p>
                </div>
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 text-info">
                    <i className="fa-solid fa-cubes me-2"></i>
                    Total Consumed Products
                  </h4>
                  <div className="dropdown">
                    <Link
                      to="/purchase-list"
                      className="view-all d-flex align-items-center"
                    >
                      <span className="ps-2 d-flex align-items-center">
                        <i className="fa-solid fa-ellipsis text-info"></i>
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData?.TotalConsumedProducts &&
                          dashboardTablesData?.TotalConsumedProducts?.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <Link
                                        to="/product-list"
                                        className="text-primary fw-bold"
                                      >
                                        {item.ProductName}
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className="head-text">
                                    Orders:{" "}
                                    <span className="text-success fw-semibold">
                                      {item.ProductsCount}
                                    </span>
                                  </p>
                                </td>
                                <td>
                                  <p className="head-text text-info fw-semibold">
                                    ₹{item.AvgPrice}
                                  </p>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 text-info">
                    <i className="fa-regular fa-paste me-2"></i>
                    Recent Purchases
                  </h4>
                  <div className="dropdown">
                    <Link
                      to="/purchase-requests"
                      className="view-all d-flex align-items-center"
                    >
                      <span className="ps-2 d-flex align-items-center">
                        <i className="fa-solid fa-ellipsis text-info"></i>
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData?.RecentPurchases &&
                          dashboardTablesData?.RecentPurchases.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <span
                                        className="fw-bold text-primary"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRightPRView"
                                        aria-controls="offcanvasRightPRView"
                                        onClick={() => showViewPRModal(item)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        PR-{item.AutoGenTransactionNo}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {item.SupplierName}
                                  {/* <p className="head-text">
                                    {formatDate(item.RequestDate)}
                                  </p> */}
                                </td>
                                <td>
                                  {/* Items */}
                                  <p className="head-text text-info fw-semibold">
                                    ₹{item.EstimateAmount}
                                  </p>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 text-info">
                    <i className="fa-solid fa-cubes-stacked me-2"></i>
                    Total Stock Worth
                  </h4>
                  <div className="dropdown">
                    <Link
                      to="/indent-list"
                      className="view-all d-flex align-items-center"
                    >
                      {/* View All */}
                      <span className="ps-2 d-flex align-items-center">
                        {/* <ArrowRight className="feather-16" /> */}
                        <i className="fa-solid fa-ellipsis text-info"></i>
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData?.TotalSTockWorth &&
                          dashboardTablesData?.TotalSTockWorth.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <p
                                        className="dull-text text-primary fw-bold"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRightIndView"
                                        aria-controls="offcanvasRightIndView"
                                        onClick={() =>
                                          showViewIndentModal(item)
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        {item.StoreName}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className="head-text text-info fw-semibold">
                                    ₹{item.StockWorth}
                                  </p>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ViewIndent IndentObj={viewIndentObj} />
        <ViewPurchaseRequest tranViewObj={viewPRObj} />
        {/* <SupplierModal supplierObj={viewSupplierObj} />
        <ViewInvocie INVObj={viewInvoiceObj} /> */}
        {/* <ViewPurchase POObj={viewPOObj} /> */}
      </div>
    </>
  );
};

export default AccountsDashboard;
